import React from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Translate, I18n } from "react-redux-i18n";
import  'assets/css/sidebar.css';
import Profile from './Sidebar/components/Profile';

import {ShoppingBag, World, List, History, SearchDollar, ChartArea, ChartBar, ChartLine, Book, QuestionCircle, AccountBox, NotebookText, Settings, Receipt, SignOut, ChevronLeft, Bell} from 'theme/icon';


const Sidebar = props => {
      const { isCollapsed, location } = props;

      const pages = [
    {
      title: <Translate value="portfolio" />,
      href: '/portfolio',
      icon: <ShoppingBag size={20}/>
    },
    {
      title: <Translate value="wall" />,
      href: '/wall',
      icon: < World size={20}/>
    },
    {
      title: <Translate value="watchlist" />,
      href: '/watchlist',
      icon: <List size={20}/>
    },
    {
      title: <Translate value="alerts" />,
      href: '/alerts',
      icon: <Bell size={20}/>
    },
    {
      title: <Translate value="history" />,
      href: '/history',
      icon: <History size={20}/>
    },
    {
      title: <Translate value="discover" />,
      href: '/discover',
      icon: <SearchDollar size={20}/>
    },
    {
      title: <Translate value="report" />,
      href: '/report',
      icon:  <ChartBar size={20}/>
    },
    {
      title: <Translate value="knowledge" />,
      href: '/knowledge',
      icon: <Book size={20}/>
    },

    {
      title: <Translate value="faq" />,
      href: '/faq',
      icon: <QuestionCircle size={20}/>
    },
    {
      title: <Translate value="account" />,
      href: '/account',
      icon: <AccountBox size={20}/>
    },
    {
      title: <Translate value="balance" />,
      href: '/balance',
      icon: <NotebookText size={20}/>
    },
    {
      title: <Translate value="setting" />,
      href: '/setting',
      icon: <Settings size={20}/>
    },
    {
      title: <Translate value="suscription" />,
      href: '/suscription',
      icon: <Receipt size={20}/>
    },
    {
      title: <Translate value="logout" />,
      href: '/login',
      icon: <SignOut size={20}/>
    }
  ];

      

    return (
        <nav className={`sidebar ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
            <Profile isCollapsed={isCollapsed} />
            <ul className="sidebar-nav">
               <li key={0} className="sidebar-item">
                            <button
                              type="button"
                              className={`sidebar-link sidebar-toggle ${isCollapsed ? 'sidebar-toggle--collapsed' : ''}`}
                              onClick={props.onToggle}
                              aria-expanded={!isCollapsed}
                              title={isCollapsed ? 'Expandir' : 'Recoger'}
                            >
                                <span className="sidebar-icon"><ChevronLeft /></span>
                                <span className="sidebar-label">Esconder</span>
                            </button>
                        </li>
                {pages.map((page, index) => {
                    const isActive = location && location.pathname === page.href;
                    return (
                        <li key={index} className={`sidebar-item ${isActive ? 'sidebar-item-active' : ''}`}>
                            <RouterLink to={page.href} className="sidebar-link">
                                <span className="sidebar-icon">{page.icon}</span>
                                <span className="sidebar-label">{page.title}</span>
                            </RouterLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};
Sidebar.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool
};
export default withRouter(Sidebar);